import React from "react";
import {Box, Button, Stack} from "@mui/material";
import DefaultDialog, {DefaultDialogSize} from "../../../components/Dialog/ClosableDialog";
import {LabeledSection} from "../../../components/Layout/Page";
import {useTranslation} from "react-i18next";
import {DeviceFlat} from "../../../app/api/model/device";
import {useOrganizationDeviceRemoveMutation} from "../../../app/api/api";
import {useSnackbar} from "notistack";
import CompactDeviceList from "./CompactDeviceList";
import {unassignedOrSameOrganization} from "./DeviceAssignToOrganizationDialog";

interface DeviceRemoveFromOrganizationDialogProps {
    open: boolean;
    onClose: () => void;
    devices?: DeviceFlat[];
}

export default function DeviceRemoveFromOrganizationDialog({
    open,
    onClose,
    devices,
}: DeviceRemoveFromOrganizationDialogProps) {
    const {t} = useTranslation();
    const [removeDevices] = useOrganizationDeviceRemoveMutation();
    const {enqueueSnackbar} = useSnackbar();
    const validDevices = unassignedOrSameOrganization(devices);

    const handleClose = () => {
        onClose?.();
    };

    const onConfirm = async () => {
        if (validDevices && devices?.length && devices[0].organizationId) {
            removeDevices({
                organizationId: devices[0].organizationId,
                deviceIds: devices.map((d) => d.id),
            })
                .unwrap()
                .then(() => {
                    enqueueSnackbar(t("generic_removalSuccessful"), {variant: "success"});
                    handleClose();
                });
        }
    };

    return (
        <DefaultDialog
            size={DefaultDialogSize.EXTRA_LARGE}
            open={open}
            titleKey={"action_removeDeviceFromOrg"}
            onClose={handleClose}
            actions={[
                <Box key="removeDeviceFromOrgButton">
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        onClick={onConfirm}
                        disabled={!validDevices}
                    >
                        {t("generic_remove")}
                    </Button>
                </Box>,
            ]}
        >
            <Stack spacing={2} pt={1}>
                <LabeledSection title={t("generic_devices")}>
                    <CompactDeviceList devices={devices} />
                </LabeledSection>
            </Stack>
        </DefaultDialog>
    );
}
